import { useQuery } from '@tanstack/react-query';
import { ORIGIN_REGIONS } from '@src/constants/region';
import queryClient from '@src/libs/react-query';
import photoCardsApiV2 from '@src/apis/photoCardsApiV2';
import { PHOTO_CARD_HOT_RANDOM } from '@src/queryKeys';

export function randomRegionIndex() {
  return Math.floor(Math.random() * 5);
}

export async function prefetchHotRandomPhotoCard() {
  let randomRegion = ORIGIN_REGIONS[randomRegionIndex()] as RankingRegionType;

  const mixedPhotoCard = await queryClient.fetchQuery({
    queryKey: [PHOTO_CARD_HOT_RANDOM, randomRegion],
    queryFn: () =>
      photoCardsApiV2
        .getHotPhotoCardRandom({
          region: randomRegion,
        })
        .then((res) => res.data),
  });

  if (!mixedPhotoCard.length) {
    await queryClient.prefetchQuery({
      queryKey: [PHOTO_CARD_HOT_RANDOM, null],
      queryFn: () =>
        photoCardsApiV2.getHotPhotoCardRandom().then((res) => res.data),
    });
    randomRegion = null;
  }

  queryClient.setQueryData(['randomRegion'], randomRegion);
}

export function useGetPhotoCardHotRandom() {
  const region = queryClient.getQueryData([
    'randomRegion',
  ]) as RankingRegionType;

  const data = useQuery({
    queryKey: [PHOTO_CARD_HOT_RANDOM, region],
    queryFn: () =>
      photoCardsApiV2
        .getHotPhotoCardRandom(
          region !== null
            ? {
                region,
              }
            : {},
        )
        .then((res) => res.data),
    ...{ staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 5 },
  });

  return { region, ...data };
}
